// SRS-01 §5.2 — Matriz de permisos por rol
// canViewSeguimientos reemplaza al viejo canViewPendientes (head=true,
// analista=true, kam=false) — INVERTIDO para kam: ahora también ve TODOS los
// seguimientos, no solo los que inició. Motivo: head lidera Digital y necesita
// visibilidad total del estatus de permisos de todas las cuentas; kam gana
// visibilidad de equipo (no solo lo propio) para dar contexto. comercial y
// digital siguen sin acceso. canMarkAliasCreated se retira (el botón
// "Marcar como completado" de Seguimientos no es un permiso fijo por rol —
// depende de si el usuario es iniciado_por del seguimiento puntual, o root;
// ver PATCH /seguimientos/:id/completar).
// Perfil de kam, compartido POR REFERENCIA con 'ads_manager' (decisión 10-oct,
// "rol kam = rol ads manager"): mismo objeto, así no pueden divergir.
const PERMISOS_KAM = {
    canViewClients: true,
    canViewContacts: true,
    canCreateClient: true,
    canEditClient: true,
    canChangeStatus: true,
    canViewLog: true,
    canManageUsers: false,
    canManageCatalogs: false,
    canManageAreaCatalogo: true, // Prompt AA — excepción: kam sí gestiona Áreas aunque no el resto de catálogos
    canViewCxC: true,
    canWriteCxC: false,
    canViewSeguimientos: true, // invertido respecto al viejo canViewPendientes (era false)
};
export const PERMISSIONS = {
    root: {
        canViewClients: true,
        canViewContacts: true,
        canCreateClient: true,
        canEditClient: true,
        canChangeStatus: true,
        canViewLog: true,
        canManageUsers: true,
        canManageCatalogs: true,
        canManageAreaCatalogo: true, // Prompt AA — root/kam/head/comercial; distinto de canManageCatalogs
        canViewCxC: true,
        canWriteCxC: true, // F.6.1 — root tiene acceso total sin excepción, incluida escritura en CxC
        canViewSeguimientos: true,
    },
    head: {
        canViewClients: true,
        canViewContacts: true,
        canCreateClient: true,
        canEditClient: true,
        canChangeStatus: true,
        canViewLog: true,
        canManageUsers: false,
        canManageCatalogs: true,
        canManageAreaCatalogo: true, // Prompt AA
        canViewCxC: true,
        canWriteCxC: false,
        canViewSeguimientos: true,
    },
    analista: {
        canViewClients: true,
        canViewContacts: true,
        canCreateClient: true,
        canEditClient: true,
        canChangeStatus: true,
        canViewLog: true,
        canManageUsers: false,
        canManageCatalogs: true,
        canManageAreaCatalogo: false, // Prompt AA — excluido a propósito, a diferencia de canManageCatalogs
        canViewCxC: true,
        canWriteCxC: false,
        canViewSeguimientos: true,
    },
    kam: PERMISOS_KAM,
    ads_manager: PERMISOS_KAM, // = kam en todo (decisión 10-oct)
    comercial: {
        canViewClients: true,
        canViewContacts: true,
        canCreateClient: false,
        canEditClient: false,
        canChangeStatus: false,
        canViewLog: true,
        canManageUsers: false,
        canManageCatalogs: false,
        canManageAreaCatalogo: true, // Prompt AA — excepción: comercial sí gestiona Áreas aunque no el resto de catálogos
        canViewCxC: true,
        canWriteCxC: false, // decisión 15-oct: el área comercial solo lee; escribe gerente_comercial
        canViewSeguimientos: false,
    },
    // Decisión 15-oct — Gerente Comercial (exclusivo de Ceci, gestora de
    // cartera): en clientes y gestión NUNCA menos que kam, más escritura
    // exclusiva en CxC (junto con root), copiar correos activos y catálogos.
    gerente_comercial: {
        canViewClients: true,
        canViewContacts: true,
        canCreateClient: true,
        canEditClient: true,
        canChangeStatus: true,
        canViewLog: true,
        canManageUsers: false,
        canManageCatalogs: true,
        canManageAreaCatalogo: true,
        canViewCxC: true,
        canWriteCxC: true, // EXCLUSIVO (junto con root)
        canViewSeguimientos: true,
    },
    digital: {
        canViewClients: true,
        canViewContacts: false, // CRÍTICO: sin contactos
        canCreateClient: false,
        canEditClient: false,
        canChangeStatus: false,
        canViewLog: true,
        canManageUsers: false,
        canManageCatalogs: false,
        canManageAreaCatalogo: false, // Prompt AA
        canViewCxC: false, // Sin acceso a CxC
        canWriteCxC: false,
        canViewSeguimientos: false,
    },
    // Prompt AF-4(RH) — CEO (Sebastian Barrios, tope del organigrama): lectura
    // equivalente a root en TODO (cada permiso "canView*" queda true, igual
    // que root), pero escritura NUNCA mayor que kam — cada permiso de
    // escritura copia el valor de kam, no el de root, aunque root lo tenga en
    // true. Confirmado explícitamente con el product owner.
    CEO: {
        canViewClients: true,
        canViewContacts: true,
        canCreateClient: true, // = kam
        canEditClient: true, // = kam
        canChangeStatus: true, // = kam
        canViewLog: true,
        canManageUsers: false, // = kam (NO root, aunque root sea true)
        canManageCatalogs: false, // = kam
        canManageAreaCatalogo: true, // = kam
        canViewCxC: true,
        canWriteCxC: false, // = kam (NO root, aunque root sea true)
        canViewSeguimientos: true,
    },
};
export function can(rol, action) {
    return PERMISSIONS[rol]?.[action] ?? false;
}
//# sourceMappingURL=permissions.js.map